import React from "react";

import PanelTemplate from "../../templates/Panel";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import { SoonPill } from "../../components/GestaoTeaser";
import { WHATSAPP_SUBSCRIPTION_URL } from "../../helpers/constants";

const UPCOMING = [
    { icon: 'items', title: 'Plano e módulos', text: 'O que está contratado e o que dá para liberar.' },
    { icon: 'receipt-text', title: 'Faturas', text: 'Boletos e Pix em aberto, recibos das pagas.' },
    { icon: 'company', title: 'Dados de cobrança', text: 'Razão social, CNPJ e e-mail que recebe as faturas.' },
];

export const Subscription = () => (
    <PanelTemplate id="subscription">
        <h1 className="subscription-title">Assinatura</h1>

        <section className="subscription-card">
            <span className="subscription-icon"><Icon name="credit-card" size={22} /></span>
            <div className="subscription-texts">
                <p className="subscription-headline">
                    Acompanhe sua assinatura por aqui
                    <SoonPill />
                </p>
                <p className="subscription-lead">
                    Em breve você vai poder ver o plano, as faturas e os dados de cobrança sem sair do sistema.
                    Enquanto isso, para falar sobre boletos, upgrade de plano ou qualquer outra questão da
                    assinatura, chame a gente no WhatsApp.
                </p>
                <Button
                    type="primary"
                    size="small"
                    text="Falar no WhatsApp"
                    action={() => window.open(WHATSAPP_SUBSCRIPTION_URL, '_blank', 'noopener')}
                />
            </div>
        </section>

        <p className="subscription-section-label">O que vai aparecer aqui</p>
        <ul className="subscription-upcoming">
            {UPCOMING.map(item => (
                <li key={item.title}>
                    <span className="subscription-upcoming-icon"><Icon name={item.icon} size={18} /></span>
                    <div>
                        <b>{item.title}</b>
                        <small>{item.text}</small>
                    </div>
                </li>
            ))}
        </ul>
    </PanelTemplate>
);

export default Subscription;
